
const initialState = {
  cryptoTransactions: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_CRYPTO_TRANSACTIONS_DATA': {
      const { cryptoTransactions } = payload;
      return {
        ...state,
        cryptoTransactions,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/CryptoTransactions/CryptoTransactions.reducer.js